var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "15.3 14.7 20.55 20.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M31.712 14.738a.607.607 0 0 0-.361.17L16.114 30.156a.607.607 0 0 0-.17.332l-.646 4.08a.607.607 0 0 0 .693.693l4.08-.646a.607.607 0 0 0 .331-.16L35.65 19.206a.607.607 0 0 0 0-.864l-3.435-3.434a.607.607 0 0 0-.502-.17zm.066 1.461l2.58 2.58-1.072 1.073-2.58-2.58 1.072-1.073zm-1.936 1.936l2.581 2.58-12.02 12.02-2.581-2.58 12.02-12.02zm-12.77 12.979l2.372 2.371-2.818.446.446-2.817z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.23365bf8326e6540ef3682e235cc76b4.svg";
export { ForwardRef as ReactComponent };